import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeHtmlTag',
    standalone: false
})
export class RemoveHtmlTagPipe implements PipeTransform {

    transform(value: string): string {
        return value?.replaceAll('<br>', ' ') ?? '';
    }

}
